import { z } from 'zod';

export const DormSchema = z.object({
    cost: z.string().optional().nullable(),
});
export type DormDTO = z.infer<typeof DormSchema>;
